// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__lkLAi","consentsList":"PatientConsents_consentsList__2qqYr","consentsListEmpty":"PatientConsents_consentsListEmpty__1Qod4"};